/* tslint:disable */
import {
  Report
} from '../index';

declare var Object: any;
export interface ReportsMediaInterface {
  "media_path": string;
  "report_id": number;
  "jira_self_url": string;
  "jira_file_id": number;
  "jira_file_name": string;
  "jira_date_created": string;
  "jira_file_size": number;
  "jira_file_mime_type": string;
  "jira_file_content_url": string;
  "jira_file_thumbnail_url": string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  reports?: Report;
}

export class ReportsMedia implements ReportsMediaInterface {
  "media_path": string;
  "report_id": number;
  "jira_self_url": string;
  "jira_file_id": number;
  "jira_file_name": string;
  "jira_date_created": string;
  "jira_file_size": number;
  "jira_file_mime_type": string;
  "jira_file_content_url": string;
  "jira_file_thumbnail_url": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  reports: Report;
  constructor(data?: ReportsMediaInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ReportsMedia`.
   */
  public static getModelName() {
    return "ReportsMedia";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ReportsMedia for dynamic purposes.
  **/
  public static factory(data: ReportsMediaInterface): ReportsMedia{
    return new ReportsMedia(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ReportsMedia',
      plural: 'ReportsMedia',
      path: 'ReportsMedia',
      properties: {
        "media_path": {
          name: 'media_path',
          type: 'string'
        },
        "report_id": {
          name: 'report_id',
          type: 'number'
        },
        "jira_self_url": {
          name: 'jira_self_url',
          type: 'string'
        },
        "jira_file_id": {
          name: 'jira_file_id',
          type: 'number'
        },
        "jira_file_name": {
          name: 'jira_file_name',
          type: 'string'
        },
        "jira_date_created": {
          name: 'jira_date_created',
          type: 'string'
        },
        "jira_file_size": {
          name: 'jira_file_size',
          type: 'number'
        },
        "jira_file_mime_type": {
          name: 'jira_file_mime_type',
          type: 'string'
        },
        "jira_file_content_url": {
          name: 'jira_file_content_url',
          type: 'string'
        },
        "jira_file_thumbnail_url": {
          name: 'jira_file_thumbnail_url',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        reports: {
          name: 'reports',
          type: 'Report',
          model: 'Report'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/ReportsMedia.ts